import { AppActionTypes, ActionTypes } from '../types/app';

export const initApp = (): AppActionTypes => ({
	type: ActionTypes.INIT,
});

export const initComplete = (): AppActionTypes => ({
	type: ActionTypes.INIT_COMPLETE,
});
